import { UserGetOneUseCase } from '../../../../application';

export default class UserGetOneService {

    async execute(event) {
        const data = await UserGetOneUseCase(event);
        return data;
    }
}
